<!-- //
Nav导航头的消息提示
@auth xuyd
@date 2022-09-10
//-->
<template>
  <div class="nav-menu" @click="goto">
    <el-tooltip content="消息">
<!--      <el-badge :dot="hasMsg > 0">-->
        <svg-icon icon="icon-msg" class="nav-icon"/>
<!--      </el-badge>-->
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'Msg',
  data() {
    return {
      url: '',
      hasMsg: 0, // 是否有消息
    }
  },
  methods: {
    goto() {
      this.$modal.alert('暂无消息')
    }
  }
}
</script>

<style scoped lang="less">
.nav-menu {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 20px;
    font-weight: 600
  }

  .nav-icon {
    width: 25px;
    height: 25px;
    overflow: hidden;
  }
}
</style>
